import { render, staticRenderFns } from "./SyaratCashout.vue?vue&type=template&id=67034544&scoped=true&"
import script from "./SyaratCashout.vue?vue&type=script&lang=js&"
export * from "./SyaratCashout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67034544",
  null
  
)

export default component.exports